import { AstraHoverCard, AstraParagraph, KeyboardShortcut, KeyboardShortcutPreview } from '~/astra'

type Props = {
    title: string
    label: string
    color: string
    shortcut: KeyboardShortcut
}

export const StatusPreview = ({ title, label, color, shortcut }: Props) => (
    <div className="border-t border-base pt-4">
        <AstraParagraph variant="body-large" weight="medium" className="mb-3">
            Forhåndsvisning
        </AstraParagraph>

        <div className="flex min-h-[112px] items-center justify-center rounded-lg bg-surface-strong p-4">
            <div className="flex flex-col items-center gap-2">
                <AstraHoverCard
                    open
                    reducedMotion
                    hoverContent={
                        <div className="flex items-center gap-2 rounded-md bg-surface-inverted px-2 py-1 text-body-small text-inverted">
                            <span>{title || 'Activitet'}</span>
                            <KeyboardShortcutPreview shortcut={shortcut} variant="inverted" />
                        </div>
                    }
                    noPadding
                    placement="top"
                    showArrow
                    variant="inverted"
                >
                    <div
                        className="inline-flex min-w-11 items-center justify-center rounded-md px-2 py-0.5 text-body-small font-hero-medium leading-body-small text-default"
                        style={{ backgroundColor: color }}
                    >
                        {label || 'A'}
                    </div>
                </AstraHoverCard>
            </div>
        </div>
    </div>
)
